export const ShippingCarrier = Object.freeze({
    FEDEX: "FEDEX",
    UNKNOWN: "UNKNOWN",
    USPS: "USPS",
});
